import bem from 'utils/bem';

export const block = bem('action-step-card');
export const actionStepCardEditBlock = bem('action-step-card-edit');
export const actionStepCardSpacerBlock = bem('action-step-card-spacer');
export const actionStepCardIconBlock = bem('action-step-card-composite-icon');
